import {useMutation, UseMutationResult} from "react-query";
import {API, CustomAxiosError} from "../../../logics/api-config";


const useApiUpdateRestaurateur = (): UseMutationResult<void, CustomAxiosError, {
    restaurateur_id: number,
    cisco_id: string | null,
}, unknown> => {
    return useMutation<void, CustomAxiosError, { restaurateur_id: number; cisco_id: string | null }>(
        async ({restaurateur_id, cisco_id}) => {
            try {
                cisco_id ?
                    await API.put(`/accounting/restaurateurs/${restaurateur_id}/cisco_id/${cisco_id}`)
                    :
                    await API.put(`/accounting/restaurateurs/${restaurateur_id}/cisco_id`);
            } catch (error) {
                throw error;
            }
        }
    );
};

export default useApiUpdateRestaurateur;
